import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class usersMultiSelectListCtrl implements IController {

  selectedNames: any;
  ngPlaceholder: any;
  onChange: Function;

  private usersRef: any;
  private loadLimit: number;
  private infiniteScroll: any;
  private queryString: any;
  private selectedKeys: any;

  /* @ngInject */
  constructor(private $user, private $infiniteScroll, private $log) {
  }

  $onInit() {
    this.usersRef = this.$user();
    this.loadLimit = 20;

    this.usersRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.usersRef, this.loadLimit, {getFullData: true});
  }

  $onChanges(changes) {
    if (changes.selectedNames) {
      this.selectedKeys = [];
      _.forEach(this.selectedNames, (id) => {
        this.selectedKeys[id] = true;
      })
    }
  }

  onToggle(userName, isSelected) {
    this.onChange({
      userNames: isSelected ? _.concat(this.selectedNames, [userName]) :
        _.filter(this.selectedNames,(id) => {
          return id !== userName;
        })
    });
  }

  submitQuery(query) {
    this.queryString = query;
    this._reload();
  }

  private _reload() {
    this.usersRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.error('Fail to $query', error);
      })
  }

  private _getQueryPayload() {
    return {
      limit: this.loadLimit,
      query: this.queryString,
      sort: 'name,asc'
    };
  }

}

angular
    .module('bringoz.admin.site-preferences')
    .component('usersMultiSelectList', {
        bindings: {
          selectedNames: '<',
          ngPlaceholder: '@?',
          onChange: '&'
        },
        template: require('./users-multi-select-list.html').default,
        controller: usersMultiSelectListCtrl
    });
